import { StandardEvents } from '@shopify/events';

class ThemeAddiWidget extends HTMLElement {
  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    this.#syncVisibility();
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#onProductSelect);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#onProductSelect);
    this.#section = null;
  }

  /**
   * @param {import('@shopify/events').ProductSelectEvent} event
   */
  #onProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      ?.then(({ detail }) => {
        if (!detail?.html) return;

        if (detail.newProduct) {
          this.dataset.productId = String(detail.newProduct.id);
        } else if (detail.productId && this.dataset.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const selector = this.dataset.blockId
          ? `theme-addi-widget[data-block-id="${this.dataset.blockId}"]`
          : 'theme-addi-widget';
        const next = detail.html.querySelector(selector);
        const price = next?.getAttribute('data-price');
        if (price) this.#setPrice(price);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[addi-widget] Event promise rejected:', error);
      });
  };

  /**
   * @param {string} price
   */
  #setPrice(price) {
    this.dataset.price = price;
    this.querySelectorAll('addi-widget, addi-widget-br, addi-product-widget').forEach((widget) => {
      widget.setAttribute('price', price);
    });
    this.#syncVisibility();
  }

  #syncVisibility() {
    const price = Number(this.dataset.price || 0);
    const min = Number(this.dataset.minAmount || 0);
    const max = Number(this.dataset.maxAmount || 0);
    const outOfRange = price < min || (max > 0 && price > max);
    this.toggleAttribute('hidden', outOfRange);
  }
}

if (!customElements.get('theme-addi-widget')) {
  customElements.define('theme-addi-widget', ThemeAddiWidget);
}
